import { z } from 'zod';
import { inferApiResultSchema } from './infer-api';

export const DemandCommentSchema = z.object({
  id: z.number(),
  accountId: z.string(),
  demandId: z.number(),
  commenterId: z.string().nullish(),
  comment: z.string(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
  deletedAt: z.date().nullish(),
  archivedAt: z.date().nullish(),
});
export type DemandCommentDto = z.infer<typeof DemandCommentSchema>;

export const GetDemandCommentResponseSchema = inferApiResultSchema(DemandCommentSchema);
export type GetDemandCommentResponseDto = z.infer<typeof GetDemandCommentResponseSchema>;

export const GetDemandCommentsResponseSchema = inferApiResultSchema(z.array(DemandCommentSchema));
export type GetDemandCommentsResponseDto = z.infer<typeof GetDemandCommentsResponseSchema>;

export const CreateDemandCommentSchema = DemandCommentSchema.omit({
  id: true,
  accountId: true,
  demandId: true,
  commenterId: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
  archivedAt: true,
});
export type CreateDemandCommentDto = z.infer<typeof CreateDemandCommentSchema>;

export const CreateDemandCommentResponseSchema = inferApiResultSchema(DemandCommentSchema);
export type CreateDemandCommentResponseDto = z.infer<typeof CreateDemandCommentResponseSchema>;

export const UpdateDemandCommentSchema = DemandCommentSchema.pick({ comment: true }).partial();
export type UpdateDemandCommentDto = z.infer<typeof UpdateDemandCommentSchema>;

export const UpdateDemandCommentResponseSchema = inferApiResultSchema(DemandCommentSchema);
export type UpdateDemandCommentResponseDto = z.infer<typeof UpdateDemandCommentResponseSchema>;
